import React from 'react';

export const DEFAULT_LIST_CONTEXT = {
  disabled: false,
  itemTag: 'span'
};

export default React.createContext(DEFAULT_LIST_CONTEXT);
